<template lang="pug">
  v-app-bar.main-header(
    app
    color="white"
    dark
  )
    v-row.justify-space-around.max-content
      v-col.pt-0.main-header__content-img(@click="$router.push({ name: 'Home' })")
        img(src='@/assets/img/svg/logo-header.svg' width="190")
      v-col
        v-row.justify-end.flex-nowrap
          .main-header__button
            v-btn(text :to="{ name: 'Home' }")
              span.primary--text.text-capitalize.font-weight-black Home
          .main-header__button
            v-btn(text :to="{ name: 'About' }")
              span.primary--text.text-capitalize.font-weight-black Quem somos
          .main-header__button
            v-btn(text :to="{ name: 'Product' }")
              span.primary--text.text-capitalize.font-weight-black Produtos
          .main-header__button
            v-btn(text :to="{ name: 'Contact' }")
              span.primary--text.text-capitalize.font-weight-black Contato
</template>

<script>
  export default {
    name: 'MainHeader',
    data: () => ({}),
  }
</script>

<style lang="sass" scoped>
@import "@/assets/style/variables.sass"

.main-header
  .v-btn
    font-size: 18px
    letter-spacing: inherit
  &__content-img
    cursor: pointer
    position: relative
  &__button
    &::after
      display: block
      content: ''
      border-bottom: 2px solid
      border-image-slice: 1
      border-image-source: linear-gradient(to left, $primary, $secondary)
      transform: scaleX(0)
      transition: transform 250ms ease-in-out
    &:hover
      &::after
        transform: scaleX(1)
      .v-btn__content span
        color: $primary !important
    .v-btn
      padding: 10px 32px !important
</style>